import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { translations } from '../data/translations'; // Adjust the path to your file
import { HttpClient } from '@angular/common/http';


declare interface Translations {
  [key: string]: { [key: string]: string };
}

export class CustomTranslateLoader implements TranslateLoader {

// translations : Translations = {
//   en: {},
//   ro: {},
//   de: {}
// };
  // constructor(private http: HttpClient) {}
  getTranslation(lang: string): Observable<any> {
    return of(translations[lang]);
  }

 
  // getTranslation(lang: string): Observable<Translations> {
  //   // Fetch the translation file from assets/data folder
  //   console.log('lang:', lang);
  //   const returnVal = this.http.get<Translations>(`/assets/data/${lang}.json`).subscribe(data => {
  //     // this.translations['lang'] = data;
  //     console.log('Translations:', this.translations);
  //     return this.translations;

  // }
  // );
  // return of(this.translations);
  // }
}

